import { Button, Dialog } from "@mui/material";
import React, { useState } from "react";
import assest from "../../json/assest";



const dialogContainer = {
  [`.MuiDialog-container`]: {
    alignItems: "flex-start",

    [`.MuiDialog-paper`]: {
      marginTop: "62px",
      boxShadow: "none"
    }
  },
};

const ModalWrapperSmall = (props) => {
  const { open, onClose, children, handleClose, className } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={className}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "473px",
          position: "relative",
          padding: "22px 15px 19px",

          [`& .cross_btn`]: {
            position: "absolute",
            minWidth: "auto",
            padding: "11px",
            top: 0,
            right: 0,
            [`&:hover`]: {
              background: '#fff'
            }
          }
        }
      }}
      sx={dialogContainer}
    >
      <Button className="cross_btn" onClick={handleClose}>
        <img src={assest.crossGray} alt="img" width={9} height={9} />
      </Button>
      {children}
    </Dialog>
  )
}

export default ModalWrapperSmall